import React from 'react';
import { CommonButtonV1 } from 'gemlux-common-components';
import { Box } from '@mui/material';
import CustomModal from '../../../V1/CustomModal/CustomModal';
import WarningSvg from '../../../../assets/img/alert-icon-circle.svg';
import { theme } from '../../../../theme/theme';

interface LimitModalProps {
  isLimitModalOpen: boolean;
  setIsLimitModalOpen: (_value: boolean) => void;
  handleManageSubscription: () => void;
}
export default function LimitModal({
  isLimitModalOpen,
  setIsLimitModalOpen,
  handleManageSubscription,
}: LimitModalProps) {
  return (
    <CustomModal
      modal
      open={isLimitModalOpen}
      title="Limit Reached"
      Icon={<Box component="img" src={WarningSvg} />}
      subTitle="Maximum number of Users has been reached. Upgrade your subscription or remove existing subordinates."
    >
      <Box display="flex" flexDirection="column" gap="8px" justifyContent="end" alignItems="center" mt={1}>
        <CommonButtonV1
          variant="contained"
          sx={{ width: '100%', backgroundColor: theme.palette.shades.lightBlueColor, marginTop: '10px' }}
          onClick={handleManageSubscription}
        >
          Upgrade Now!
        </CommonButtonV1>
        <CommonButtonV1
          variant="outlined"
          sx={{
            width: '100%',
            color: '#5261FE',
            border: `1px solid ${theme.palette.shades.grayBorder}`,
          }}
          backgroundColor="transparent"
          onClick={() => setIsLimitModalOpen(false)}
        >
          Cancel
        </CommonButtonV1>
      </Box>
    </CustomModal>
  );
}
